// OnboardingLayout.js
import React from 'react';
import { Container, Card } from 'react-bootstrap';

const OnboardingLayout = ({ children }) => {
  return (
    <div
      style={{
        background: 'transparent', //'linear-gradient(to bottom, #f8f9fa, #e9ecef)',
        minHeight: '50vh',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <Card
        className="shadow-lg w-100"
        style={{
          maxWidth: '960px',
          minHeight: '50vh',
          padding: '40px',
          borderRadius: '16px',
        }}
      >
        {children}
      </Card>
    </div>
  );
};

export default OnboardingLayout;